import React from 'react';
import styled from 'styled-components';
import { grey75, white } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const ExpandSVG = styled(Icon).attrs({ viewBox: '0 0 22 22' })``;

const Expand = ({ color = grey75, innerColor = white, ...props }) => (
    <ExpandSVG
        data-test="icon-expand"
        {...props}
    >
        <path
            d="M11 0a11 11 0 1 0 11 11A11.012 11.012 0 0 0 11 0zm0 20a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9zm5.5-8H12v4.5h-2V12H5.5v-2H10V5.5h2V10h4.5z"
            fill={color}
        />
        <circle
            cx="11"
            cy="11"
            fill={color}
            r="11"
        />
        <circle
            cx="11"
            cy="11"
            fill={innerColor}
            r="9"
        />
        <path
            d="M16.5 12H12v4.5h-2V12H5.5v-2H10V5.5h2V10h4.5v2z"
            fill={color}
        />
    </ExpandSVG>
);

export {
    Expand as default,
    Expand,
};
